import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const itemKey = (i) => i.key || i.id;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("al_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem("al_cart", JSON.stringify(items)); }, [items]);

  const add = (product, variant = null) => setItems((list) => {
    const key = variant ? `${product.id}:${variant.label}` : product.id;
    const found = list.find((i) => itemKey(i) === key);
    if (found) return list.map((i) => (itemKey(i) === key ? { ...i, qty: i.qty + 1 } : i));
    return [...list, {
      key,
      id: product.id,
      name: variant ? `${product.name} — ${variant.label}` : product.name,
      price: variant ? variant.price : product.price,
      size: product.size,
      image_url: product.image_url,
      digital: product.category === "Gift Cards",
      variant: variant?.label || null,
      qty: 1,
    }];
  });

  const setQty = (key, qty) =>
    setItems((list) => (qty <= 0 ? list.filter((i) => itemKey(i) !== key) : list.map((i) => (itemKey(i) === key ? { ...i, qty } : i))));

  const clear = () => setItems([]);
  const count = items.reduce((n, i) => n + i.qty, 0);
  const subtotal = items.reduce((n, i) => n + i.price * i.qty, 0);

  const value = useMemo(() => ({ items, add, setQty, clear, count, subtotal }), [items]);
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}
